import { useEffect, useState, useCallback } from "react";
import { Search } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const categories = ["All", "T-Shirts", "Stickers", "Hats", "Home Goods", "Custom Designs"];

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("All");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    const params = {};
    if (category !== "All") params.category = category;
    if (search) params.search = search;
    api.get("/products", { params }).then((res) => {
      setProducts(res.data);
      setLoading(false);
    });
  }, [category, search]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <div data-testid="shop-page">
      <section className="border-b-2 border-[#1C1C1C] bg-[#F5F2EA] grain relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 relative">
          <h1 className="font-display text-6xl md:text-7xl">The Shop</h1>
          <p className="text-lg text-[#4A4A4A] mt-3 max-w-xl">Vintage-inspired tees, stickers, hats, and home goods — all made with Midwest grit.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10">
        <div className="flex flex-col md:flex-row gap-4 md:items-center justify-between mb-10">
          <div className="flex flex-wrap gap-2">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setCategory(c)}
                data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
                className={`px-4 py-2 font-display text-xl uppercase tracking-wide border-2 border-[#1C1C1C] transition-all ${
                  category === c ? "bg-[#1C1C1C] text-[#FDFBF7]" : "bg-transparent hover:bg-[#EDE8DD]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="relative md:w-72">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#4A4A4A]" />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search products…"
              data-testid="shop-search"
              className="w-full pl-10 pr-4 py-3 border-2 border-[#1C1C1C] bg-transparent focus:outline-none focus:border-[#D35400] font-medium"
            />
          </div>
        </div>

        {loading ? (
          <p className="font-display text-3xl text-[#4A4A4A] py-20 text-center">Loading…</p>
        ) : products.length === 0 ? (
          <p className="font-display text-3xl text-[#4A4A4A] py-20 text-center" data-testid="shop-empty">No products found.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" data-testid="product-grid">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Shop;
